import { graphql } from "gql";

const DELETE_MESSAGE_MUTATION = graphql(`
  mutation DeleteMessage($id: ID!) {
    editMessage(id: $id, input: { isDeleted: true }) {
      ...Message
    }
  }
`);

export default DELETE_MESSAGE_MUTATION;
